import React, { useState } from "react";
import {
  Box,
  FormControlLabel,
  Grid,
  RadioGroup,
  Typography,
  Radio,
  FormControl,
  TextField,
} from "@mui/material";

const StepFive = ({ selectedOption, setSelectedOption }) => {
  const [customInput, setCustomInput] = useState("");

  const handleChange = (event) => {
    const value = event.target.value;
    if (value !== "other") {
      setCustomInput("");
      setSelectedOption(value);
    } else {
      setSelectedOption("");
    }
  };

  const handleCustomInputChange = (e) => {
    const value = e.target.value;
    setCustomInput(value);
    setSelectedOption(value);
  };

  return (
    <Box>
      <Grid container justifyContent={"center"}>
        <Grid item xs={12} sm={8} md={4.5}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: "400",
              fontSize: "14px",
              marginBottom: "15px",
              color: "rgb(178 181 178)",
            }}
          >
            Account Setup
          </Typography>
          <Typography
            variant="h3"
            sx={{ fontWeight: "700", fontSize: "30px", marginBottom: "15px" }}
          >
            How did you hear about Loba?
          </Typography>
          <Box
            sx={{
              padding: "25px",
              border: "1px solid rgb(178 181 178)",
              borderRadius: "15px",
            }}
          >
            <FormControl>
              <RadioGroup
                value={
                  [
                    "recommended",
                    "searchEngine",
                    "socialMedia",
                    "email",
                    "ad",
                    "ratingWeb",
                  ].includes(selectedOption)
                    ? selectedOption
                    : "other"
                }
                onChange={handleChange}
              >
                <FormControlLabel
                  value="recommended"
                  control={<Radio />}
                  label="Recommended by a friend"
                />
                <FormControlLabel
                  value="searchEngine"
                  control={<Radio />}
                  label="Search engine (e.g. Google, Bing)"
                />
                <FormControlLabel
                  value="socialMedia"
                  control={<Radio />}
                  label="Social media"
                />
                <FormControlLabel
                  value="email"
                  control={<Radio />}
                  label="Advert in the mail"
                />
                <FormControlLabel
                  value="ad"
                  control={<Radio />}
                  label="Magazine ad"
                />
                <FormControlLabel
                  value="ratingWeb"
                  control={<Radio />}
                  label="Rating website (e.g. Capterra, Trustpilot)"
                />
                <FormControlLabel
                  value="other"
                  control={<Radio />}
                  label="Other"
                />
              </RadioGroup>

              {[
                "recommended",
                "searchEngine",
                "socialMedia",
                "email",
                "ad",
                "ratingWeb",
              ].includes(selectedOption) === false && (
                <Box sx={{ width: 420, mt: 2 }}>
                  <TextField
                    fullWidth
                    label="Please specify"
                    variant="outlined"
                    value={customInput}
                    onChange={handleCustomInputChange}
                  />
                </Box>
              )}
            </FormControl>
          </Box>

          {selectedOption && (
            <Typography sx={{ marginTop: "15px", fontWeight: "600" }}>
              Selected Option: {selectedOption}
            </Typography>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default StepFive;
